var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.883,
    height: 21.451,
    viewBox: "0 0 22.883 21.451",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.251,205.55h-15.2A2.058,2.058,0,0,1,40,203.495V192.678a.715.715,0,0,1,1.43,0v10.817a.626.626,0,0,0,.626.626h15.2a.626.626,0,0,0,.626-.626V192.678a.715.715,0,0,1,1.43,0v10.817A2.058,2.058,0,0,1,57.251,205.55Z",
    transform: "translate(-38.212 -184.099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.168,27.1a.713.713,0,0,1-.506-.209L12.769,18a1.879,1.879,0,0,0-2.655,0L1.221,26.889A.715.715,0,0,1,.21,25.877L9.1,16.984a3.311,3.311,0,0,1,4.677,0l8.893,8.893a.715.715,0,0,1-.506,1.221Z",
    transform: "translate(0 -16.017)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M182.436,297.279h-5.721a.715.715,0,0,1-.715-.715v-6.346a2.237,2.237,0,0,1,2.235-2.235h2.682a2.237,2.237,0,0,1,2.235,2.235v6.346A.715.715,0,0,1,182.436,297.279Zm-5.006-1.43h4.291v-5.631a.805.805,0,0,0-.8-.8h-2.682a.805.805,0,0,0-.8.8Z",
    transform: "translate(-168.134 -275.828)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.2433189e.svg";
export { ForwardRef as ReactComponent };